import React, { createContext, useContext } from 'react';
import useFormEditor from '../../hooks/useFormEditor';

const BuilderEditorContext = createContext(null);

export const BuilderEditorProvider = ({ children, formId, langId }) => {
  const editor = useFormEditor(formId, langId);
  return (
    <BuilderEditorContext.Provider value={editor}>
      {children}
    </BuilderEditorContext.Provider>
  );
};

export const useBuilderEditor = () => {
  const ctx = useContext(BuilderEditorContext);
  if (!ctx) throw new Error('useBuilderEditor must be used within BuilderEditorProvider');
  return ctx;
};

export default BuilderEditorContext;
